import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  Text,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import * as React from "react";
import { useMutation } from "react-query";
import { addOrganization, downloadCSV } from "../../../../api";

interface NewOrganizationPopupProps {
  onOrganizationAdded?: () => void;
}

export const NewOrganizationPopup = ({ onOrganizationAdded }: NewOrganizationPopupProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [name, setName] = React.useState("");
  const [error, setError] = React.useState<string | null>(null);

  const initialRef = React.useRef(null);

  const { mutate, isLoading } = useMutation(addOrganization, {
    onSuccess: () => {
      onClose();
      if (onOrganizationAdded) onOrganizationAdded();
    },
    onError: (err) => {
      setError("Sorry, new organization could not be added at this time.");
    },
  });

  const renderError = () => {
    if (error) {
      return (
        <Text color="red" mt={4}>
          {error}
        </Text>
      );
    }
    return null;
  };

  const handleAddClick = async () => {
    setError(null);

    if (!name) {
      setError("Please enter a unique name.");
      return;
    }

    mutate({ name });
  };

  return (
    <>
      <Button onClick={onOpen}>New Organization</Button>
      <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Organization</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl>
              <FormLabel>Name</FormLabel>
              <Input
                ref={initialRef}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </FormControl>

            {renderError()}
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={handleAddClick}
              isLoading={isLoading}
            >
              Add
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
